import {
  TPropertySocioeconomicLevel,
  TPropertyType,
  TPropertyTransactionType,
  TPropertyStatus,
} from "../typos/properties";

export const SELevel: TPropertySocioeconomicLevel[] = [1, 2, 3, 4, 5, 6];

export const TransactionType: Record<TPropertyTransactionType, string> = {
  RENT: "Arriendo",
  SALE: "Venta",
};

export const PropertyType: Record<TPropertyType, string> = {
  APARTMENT: "Apartamento",
  HOUSE: "Casa",
  LOT: "Lote",
  WAREHOUSE: "Bodega",
  OFFICE: "Oficina",
  BUILDING: "Edificio",
  COMMERCIAL: "Local comercial",
};

export const PropertyStatus: Record<TPropertyStatus, string> = {
  WAITING_FOR_APPROVAL: "Anúncio en revisón",
  INACTIVE: "Inactivo",
  PAUSED_BY_APPLICATION: "Pausado por tuHogar",
  PAUSED_BY_USER: "Pausado",
  ACTIVE: "Activo",
};
